import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import {debounceTime, map, startWith} from 'rxjs/operators';
import { ModalDialog } from 'src/app/modal/modal';
import { SettingsService } from 'src/app/settings/settings.service';;
declare var $ :any;


@Component({
    selector: 'cambiar-empresa',
    templateUrl: './cambiar-empresa.html',
    styleUrls: ['./cambiar-empresa.less'],
    standalone: false
})


export class CambiarEmpresa implements OnInit {
   
  element:any;
  se_abrio_desde_clave:boolean=false;


  constructor(public snackBar: MatSnackBar, 
    private router: Router, public dialog: MatDialog,  
    public settings: SettingsService, private dialogRef: MatDialogRef<CambiarEmpresa>){

  }


  stateCtrl = new FormControl();
  filteredStates!: Observable<State[]>;
  toHighlight: string = '';

  states:State[]=[]
  public selected2:any;
  rol:any;

  empresa_valida: boolean = true;


  ngOnInit() {
    this.rol = localStorage.getItem('role')
    this.myControl.disable();
    this.empresas_relacionadas()

    this.myControl.valueChanges.subscribe(() => {
      if (!this.empresa_valida) {
        this.empresa_valida = true;
      }
    });
  }

  myControl = new FormControl();
  filteredOptions!: Observable<string[]>;
  options: State[] = [];

  filterStates(name: string) {
    this.toHighlight = name;
    return this.states.filter(state =>
      state.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }


  company_selected="";
  load:boolean=false;
  async load_companies() {
    try {
      this.options = [];
      this.states = [];
  
      this.load = true;

      const bd: any = await this.settings.get_query(1, '/cliente/empresas-relacionadas/');
      var body_data: any =bd._body;
      switch (bd.status) {
        case 200:

        let company_id = "";

        console.log(body_data)

        for(let i=0;i<body_data.success.info.length;i++){
          let id=body_data.success.info[i].company_id;
          let name=body_data.success.info[i].business_name;
          let rut=body_data.success.info[i].rut;
          let ruta=body_data.success.info[i].ruta;

          this.states.push({
            id:id, name:name,rut:rut, ruta:ruta
          })
          this.options.push({
            id:id, name:name,rut:rut, ruta:ruta
          })

          this.filteredStates = this.stateCtrl.valueChanges
          .pipe(
            startWith(''),
            map((state:any) => state ? this.filterStates(state) : this.states.slice())
          );


        }

        if (body_data.success.info.length > 0)
        {
          
          let company_id = Number(localStorage.getItem('company_id'))
          this.selected2 = Number(localStorage.getItem('company_id')) //company_id

          let ttt = body_data.success.info.find((obj:any) => obj.company_id == company_id)
          if (ttt != null){
            this.myControl.setValue(ttt.business_name)
            this.company_selected = ttt.business_name;
            this.element.company_selected = (this.TextAbstract(ttt.business_name, 75)).toUpperCase();
          }

        
          
        }


        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          debounceTime(300),
          map((value:any) => this._filter(value))
        );




        
        
          this.load = false;



          break;
        default:

          break;
      }
    } catch (bd: any) {

    }
  }

  findObjectByKey(array:any, key:any, value:any) {
    for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
            return array[i];
        }
    }
    return null;
  }


  private _filter(value: any): any[] {

    let filterValue;
    if(value.name){
      filterValue = value.name.toLowerCase();
    }else{
      filterValue = value.toLowerCase();
    }


    return this.options.filter(option => option.name.toLowerCase().includes(filterValue) === true).slice(0, 100);;
  }


  id_company:any;
  ruta:any;
  nombre_empresa: string = "";
  rut:string="";
  selected = ($e:any) => {

    this.ruta = $e.option.value.ruta;
    this.id_company = $e.option.id
    this.nombre_empresa = $e.option.value.name;
    this.rut = $e.option.value.rut;
    this.empresa_valida = true;
  }

  displayFn(option: any): string {
    return option && option.name ? option.name : option;
  }

  aceptar(){



     if (!this.id_company || !this.nombre_empresa) {
      this.empresa_valida = false;
      this.myControl.setValue('');

      this.snackBar.open('Debe seleccionar una empresa válida de la lista ', 'Aceptar', {
        duration: 4000,
        panelClass: ['simpli-snack']
      });

      return;
    }

    let id_company = this.id_company;
    localStorage.setItem('company_id', String(id_company));
    localStorage.setItem('business_name', String(this.nombre_empresa));
    localStorage.setItem('rut', String(this.rut));
    const event = new CustomEvent('companyIdChanged', { detail: this.id_company });
    window.dispatchEvent(event);




    
    
    this.showmsg = true;

    this.dialogRef.close();


    this.open_input_dialog("Cambiar empresa activa", "Cambio correcto",
      `Se cambio la empresa activa`,
      "Ahora podras visualizar la información de la empresa seleccionada","check_circle","#3BA46F");

    if(this.se_abrio_desde_clave == true){

      console.log("ACA", this.se_abrio_desde_clave)
      this.element.ngOnInit();
      this.element.reset_parent();
  
    } else {
      this.get_step(id_company);

      // if (this.router.url.includes('ver-detalle') ||
      //     this.router.url.includes('detalle-operacion') ||
      //     this.router.url.includes('operation-detail') ||
      //     this.router.url.includes('simulacion') ||
      //     this.router.url.includes('ver-detalle-rechazada') ||
      //     this.router.url.includes('resumen-facturas')) {
      //   this.router.navigate(['home'], { replaceUrl: true });
      // } else {
      //   if (!this.ruta) {
      //     this.router.navigate(['home']);
      //   } else if (this.ruta.includes('home/onboarding')) {
      //     this.router.navigate([this.ruta]).then(() => {
      //     window.location.reload();
      //   });
      //   } else {
      //     this.router.navigate([this.ruta]);
      //   }
      // }
    }
  }

  showmsg:boolean=false;

  TextAbstract(text:any, length:any) {
    if (text == null) {
        return "";
    }
    if (text.length <= length) {
        return text;
    }
    text = text.substring(0, length);
    var last = text.lastIndexOf(" ");
    text = text.substring(0, last);
    return text + "..";
  }

  async empresas_relacionadas() {
    this.options = [];
    this.states = [];
    try {
      this.load = true;
      const bd: any = await this.settings.get_query(1, 'cliente/empresas-relacionadas/');
      var body_data: any =bd._body;
      var data = body_data.success.info;
      switch (bd.status) {
        case 200:

          if (data.length > 0) {

            for(let i in data){

   
                this.states.push({
                  id:data[i].company_id, name:data[i].business_name,rut:data[i].rut, ruta:data[i].ruta
                })
                this.options.push({
                  id:data[i].company_id, name:data[i].business_name,rut:data[i].rut, ruta:data[i].ruta
                })

            }


            this.filteredStates = this.stateCtrl.valueChanges
            .pipe(
              startWith(''),
              map((state:any) => state ? this.filterStates(state) : this.states.slice())
            );

            let company_id = Number(localStorage.getItem('company_id'))
            this.selected2 = Number(localStorage.getItem('company_id'))
            let empresa = data.find((obj:any) => obj.company_id == company_id)
            if (empresa != null){
              this.myControl.setValue(empresa.business_name)
              this.company_selected = empresa.business_name;
              this.element.company_selected = (this.TextAbstract(empresa.business_name, 75)).toUpperCase();
              localStorage.setItem('business_name', (this.TextAbstract(empresa.business_name, 75)).toUpperCase())
            }
          }
          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            debounceTime(0),
            map((value:any) => this._filter(value))
          );
          this.load = false;

          this.myControl.enable();


          
        break;
        default:
          this.load = false;
        break;
      }
    } catch (bd:any) {
      console.log("error", bd)
      this.load = false;
      this.myControl.enable();
      this.settings.manage_errors(bd.status, "Cambiar empresa", bd);
    }
  }




  open_input_dialog(title:any,subtitle:any,mensajeprincipal:any, mensajenegrita:any,icon:any,coloricon:any) {
    const dialogRef = this.dialog.open(ModalDialog, {
      width: '700px',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.subtitle = subtitle;
    dialogRef.componentInstance.mensajeprincipal = mensajeprincipal;
    dialogRef.componentInstance.mensajenegrita = mensajenegrita;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.coloricon = coloricon;
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  stepBackend!: number;
  id_simulation!: number;
  
  async get_step(id_company: any){
    try {
      const bd: any = await this.settings.get_query(1, `cliente/obtener-paso-company/${id_company}/`, );
      var body_data: any = bd._body;  

      this.stepBackend = body_data.success.step;
      let ruta = body_data.success.ruta;

      if(body_data.success.simulation_id != 0){
        this.id_simulation = body_data.success.simulation_id;
      }

      if (ruta.includes('onboarding')) {
        this.router.navigate(['home/onboarding']).then(() => {
          window.location.reload();
        });
      } else {
         this.router.navigate(['home']);
      }

    } catch (bd:any) {
      console.error('Error al obtener el paso del backend');
    }
  }

}



export interface State {
  id: any;
  name:any,
  rut:any,
  ruta: any
  
}